import { Options } from 'highcharts';
import { primaryDefaultChartColor } from '@constants/highcharts-vue';

export default class DataVisualizationBaseChart {
	getOptions(): Options {
		const dataLabelColor = '#242628';
		const labelColor = 'hsl(210,5%,55%)';
		const lineColor = 'hsl(210,10%,85%)';

		return {
			chart: {
				backgroundColor: 'transparent',
				spacing: [8, 0, 0, 0],
				style: {
					fontFamily: '"Source Sans Pro","Helvetica Neue","Helvetica","Arial",sans-serif'
				}
			},
			credits: {
				enabled: false
			},
			lang: {
				thousandsSep: ','
			},
			legend: {
				enabled: false
			},
			plotOptions: {
				area: {
					color: primaryDefaultChartColor,
					fillColor: {
						linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
						stops: [
							[0, 'rgba(128,191,255,0.5)'],
							[1, 'rgba(128,191,255,0)']
						]
					},
					marker: {
						enabled: false,
						symbol: 'circle'
					},
					threshold: null
				},
				column: {
					color: primaryDefaultChartColor,
					dataLabels: {
						inside: false,
						style: {
							color: '#242628',
							fontSize: '18px',
							fontWeight: 'normal'
						}
					}
				},
				line: {
					color: primaryDefaultChartColor,
					marker: {
						symbol: 'circle'
					}
				},
				pie: {
					borderWidth: 3,
					borderColor: '#ffffff',
					dataLabels: {
						enabled: false
					},
					innerSize: 158,
					size: 194,
					slicedOffset: 0,
					states: {
						hover: {
							brightness: -0.1
						}
					}
				},
				series: {
					dataLabels: {
						style: {
							color: dataLabelColor
						}
					},
					states: {
						hover: {
							enabled: false
						}
					}
				}
			},
			title: {
				text: undefined
			},
			tooltip: {
				enabled: false,
				backgroundColor: '#ffffff',
				borderColor: undefined,
				borderWidth: 0,
				xDateFormat: '%b %e %Y',
				useHTML: true
			},
			xAxis: {
				labels: {
					style: {
						color: labelColor,
						fontSize: '12px'
					}
				},
				tickColor: lineColor,
				title: {
					text: null,
					style: {
						color: labelColor
					}
				},
				lineColor
			},
			yAxis: {
				gridLineColor: lineColor,
				labels: {
					style: {
						color: labelColor,
						fontSize: '12px'
					},
					x: -8
				},
				tickColor: lineColor,
				title: {
					text: null,
					style: {
						color: labelColor
					}
				},
				lineColor
			}
		};
	}
}
